import { render, staticRenderFns } from "./YieldRates.vue?vue&type=template&id=66b813c1&"
import script from "./YieldRates.vue?vue&type=script&lang=js&"
export * from "./YieldRates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports